import React, { Component } from 'react';

import api from '../../../api/';

import Create from "./Create.js";
import Delete from "./Delete.js";
import Detail from "./Detail.js";
import Edit from "./Edit.js";

import ParadigmaTable from "../../../components/ParadigmaTable/"


class Plantillas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                },
                {
                    Header: "Descripción",
                    id: "descripcion",
                    accessor: "descripcion",
                    show: true,
                },
                {
                    Header: "Asunto",
                    id: "asunto",
                    accessor: "asunto",
                    show: true,
                }
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { action } = this.props.match.params;
        return (

            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: Create,
                        permission: 'config_email_plantillas_add',
                    },
                    {
                        edit: true,
                        component: Edit,
                        permission: 'config_email_plantillas_edit',
                    },
                    {
                        detail: true,
                        component: Detail,
                        permission: 'config_email_plantillas_detail',
                    },
                    {
                        edit: true,
                        component: Delete,
                        permission: 'config_email_plantillas_delete',
                    }
                ]}
                apiUrl={api.email.plantillas.list}
                columns={this.state.columns}
                exportUrl={api.email.plantillas.export}
                title={"Plantillas de Mail"}
            />
        );
    }

}

export default Plantillas;



// WEBPACK FOOTER //
// ./src/views/Config/Plantillas/Plantillas.js